import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './authSlice';
import { vacancyRequestsReducer } from './vacancyRequestsSlice';
import { candidatesReducer } from './candidatesSlice';
import { vacanciesReducer } from './vacanciesSlice';
import { tasksReducer } from './tasksSlice';
import { organisationDepartmentReducer } from './organisationDepartmentSlice';
import { vacancyCandidatesReducer } from './vacancyCandidatesSlice';
import { userOrganisationsReducer } from './userOrganisationsSlice';
import { analyticsReducer } from './analyticsSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        vacancyRequests: vacancyRequestsReducer,
        candidates: candidatesReducer,
        vacancies: vacanciesReducer,
        tasks: tasksReducer,
        organisationDepartment: organisationDepartmentReducer,
        vacancyCandidates: vacancyCandidatesReducer,
        userOrganisations: userOrganisationsReducer,
        analytics: analyticsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
});
